"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var material_1 = require("@angular/material");
var common_1 = require("@angular/common");
var base_portfolio_config_dialog_component_1 = require("./base-portfolio-config-dialog/base-portfolio-config-dialog.component");
var operators_1 = require("rxjs/operators");
var Observable_1 = require("rxjs/Observable");
var column_type_1 = require("@synisys/idm-portfolio-control/app/controls/model/column-type");
var base_portfolio_config_model_1 = require("../../../common/model/base-portfolio-config.model");
var base_portfolio_helper_service_1 = require("../../../common/service/base-portfolio-helper.service");
var root_entity_config_model_1 = require("../../../common/model/root-entity-config.model");
var lodash_1 = require("lodash");
var BasePortfolioConfigComponent = /** @class */ (function () {
    function BasePortfolioConfigComponent(basePortfolioHelperService, route, location, dialog) {
        this.basePortfolioHelperService = basePortfolioHelperService;
        this.route = route;
        this.location = location;
        this.dialog = dialog;
        this.replaySubjects = [];
        this.showPortfolio = false;
    }
    BasePortfolioConfigComponent.prototype.ngOnInit = function () {
        this.portfolioConfig$ = this.constructPreviewPortfolioControlModel(this.config.basePortfolioConfigModel);
    };
    BasePortfolioConfigComponent.prototype.openPortfolioDialog = function () {
        var _this = this;
        var dialogConfig = base_portfolio_config_dialog_component_1.BasePortfolioConfigDialogComponent.getConfig(this.config.basePortfolioConfigModel ? lodash_1.cloneDeep(this.config.basePortfolioConfigModel) :
            new base_portfolio_config_model_1.BasePortfolioConfigModel(), this.category, this.category);
        this.dialog.open(base_portfolio_config_dialog_component_1.BasePortfolioConfigDialogComponent, dialogConfig).afterClosed()
            .pipe(operators_1.take(1))
            .subscribe(function (returnedItemConfig) {
            if (returnedItemConfig) {
                _this.config.basePortfolioConfigModel = lodash_1.cloneDeep(returnedItemConfig);
                _this.showPortfolio = false;
                _this.portfolioConfig$ = _this.constructPreviewPortfolioControlModel(_this.config.basePortfolioConfigModel);
            }
        });
    };
    BasePortfolioConfigComponent.prototype.constructPreviewPortfolioControlModel = function (config) {
        var _this = this;
        if (config) {
            // const defaultFilter = new PortfolioFilterDto(new FilterBuilder().isNull('DateCreated').build(), null);
            return this.basePortfolioHelperService.constructBasePortfolio(config, this.category, null)
                .pipe(operators_1.tap(function (configs) {
                configs.portfolioConfig.columns.filter(function (column) { return column.columnType === column_type_1.ColumnType.TEMPLATE; })
                    .forEach(function (templateColumn) {
                    _this.replaySubjects.push(templateColumn.template$);
                });
                setTimeout(function () { return _this.afterFieldsInit(); }, 0);
            }));
        }
        return Observable_1.Observable.of(null);
    };
    BasePortfolioConfigComponent.prototype.afterFieldsInit = function () {
        var _this = this;
        this.showPortfolio = true;
        this.replaySubjects.forEach(function (replaySubject, index) {
            replaySubject.next(_this.viewContainerRefs.toArray()[index]['_data']['template']);
        });
    };
    __decorate([
        core_1.ViewChildren('customComponentContainer', { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.QueryList)
    ], BasePortfolioConfigComponent.prototype, "viewContainerRefs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", root_entity_config_model_1.RootEntityConfigModel)
    ], BasePortfolioConfigComponent.prototype, "config", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], BasePortfolioConfigComponent.prototype, "category", void 0);
    BasePortfolioConfigComponent = __decorate([
        core_1.Component({
            selector: "ejustice-base-portfolio-config",
            styles: [require('./base-portfolio-config.component.css')],
            template: require('./base-portfolio-config.component.html'),
        }),
        __metadata("design:paramtypes", [base_portfolio_helper_service_1.BasePortfolioHelperService,
            router_1.ActivatedRoute,
            common_1.Location,
            material_1.MatDialog])
    ], BasePortfolioConfigComponent);
    return BasePortfolioConfigComponent;
}());
exports.BasePortfolioConfigComponent = BasePortfolioConfigComponent;
//# sourceMappingURL=base-portfolio-config.component.js.map